import type { CommunityGroupFormProps } from "@/modules/community-groups/components/community-group-editor/CommunityGroupForm";
import { useTranslation } from "@/translations";

export function useHelpCategoryFormTranslations(isEditMode: boolean): CommunityGroupFormProps["translations"] {
  const { t } = useTranslation();

  return {
    title: isEditMode
      ? t("page.help-category.create-or-edit.edit-mode.title")
      : t("page.help-category.create-or-edit.create-mode.title"),
    actionFinish: isEditMode ? t("component.wizard.action.edit.finish") : t("component.wizard.action.create.finish"),
    fieldName: "model.help-category.name",
    fieldNamePlaceholder: t("model.help-category.name.placeholder"),
    fieldDescription: "model.help-category.description",
    fieldDescriptionPlaceholder: t("model.help-category.description.placeholder"),
    fieldIcon: t("model.help-category.icon-char"),
    fieldIconDescription: t("model.help-category.icon-char.description"),
    fieldIconPlaceholder: t("model.help-category.icon-char.placeholder"),
    fieldImage: t("model.help-category.image"),
    fieldImageDescription: t("model.help-category.image.description"),
    fieldImagePlaceholder: t("model.help-category.image.placeholder"),
    fieldAddressDescription: t("page.help-category.create-or-edit.constraint.address.description"),
    fieldBuildingDescription: t("page.help-category.create-or-edit.constraint.building.description"),
    fieldCompanyDescription: t("page.help-category.create-or-edit.constraint.company.description"),
    fieldFloorDescription: t("page.help-category.create-or-edit.constraint.floor.description"),
    appPreviewTitle: t("page.help-category.create-or-edit.app-preview.title"),
    appPreviewOpen: t("page.help-category.create-or-edit.app-preview.open"),
    canComment: t("model.permission.community.help-category.can-comment"),
    canCreateAnnouncement: t("model.permission.community.help-category.can-create-announcement"),
    canCreatePost: t("model.permission.community.help-category.can-create-post"),
    canListPosts: t("model.permission.community.help-category.can-list-posts"),
  };
}
